import React from 'react';

interface NavbarChevronIconProps {
  readonly direction: 'left' | 'right';
}

function NavbarChevronIcon({ direction }: NavbarChevronIconProps): React.ReactElement {
  return (
    <svg
      className={
        direction === 'right'
          ? 'order-detail-navbar-icon order-detail-navbar-icon-flip'
          : 'order-detail-navbar-icon'
      }
      viewBox="0 0 24 24"
      width="18"
      height="18"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M 15 5 L8 12 L15 19"
        fill="none"
        stroke="currentColor"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NavbarChevronIcon;
